import { gql } from '@apollo/client'
import { useSubscription } from '@apollo/client/react'

export const VITALS_WIDGET_SUBSCRIPTION = gql`
  subscription VitalsWidget($patientId: ID!) {
    vitalsWidget(patientId: $patientId) {
      weight {
        creationDate
        notes
        value
      }
      temperature {
        creationDate
        notes
        value
      }
      heartRate {
        creationDate
        notes
        value
      }
      respirationRate {
        creationDate
        notes
        value
      }
      capillaryRefillTime {
        creationDate
        notes
        value {
          id
          name
        }
      }
      mucousMembraneColorId {
        creationDate
        notes
        value {
          id
          name
        }
      }
      mucousMembraneMoistureId {
        creationDate
        notes
        value {
          id
          name
        }
      }
      skinTurgorId {
        creationDate
        notes
        value {
          id
          name
        }
      }
      bodyConditionScore {
        creationDate
        notes
        value
      }
      fearAnxietyScore {
        creationDate
        notes
        value
      }
      painScore {
        creationDate
        notes
        value
      }
      dyspnea {
        creationDate
        notes
        value
      }
      mentationId {
        creationDate
        notes
        value {
          id
          name
        }
      }
      pulseCharacterId {
        creationDate
        notes
        value {
          id
          name
        }
      }
      bloodPressure {
        creationDate
        notes
        value
      }
      spo2 {
        creationDate
        notes
        value
      }
      etco2 {
        creationDate
        notes
        value
      }
      o2Level {
        creationDate
        notes
        value
      }
      isoSevoLevel {
        creationDate
        notes
        value
      }
      recumbencyId {
        creationDate
        notes
        value {
          id
          name
        }
      }
      muscleMassScore {
        creationDate
        notes
        value
      }
    }
  }
`

export const useVitalsWidgetSubscription = (patientId: string) =>
  useSubscription(VITALS_WIDGET_SUBSCRIPTION, {
    variables: { patientId },
    skip: !patientId,
  })
